(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').factory('IosDocumentHelper', [
        'Bridge',
        IosDocumentHelper
    ]);

    function IosDocumentHelper(
        Bridge
    ) {
        return {
            openDocumentInSeparateTab: openDocumentInSeparateTab                
        };

        function openDocumentInSeparateTab(documentGetStaticUrlPromise) {
            documentGetStaticUrlPromise.then(function(url) {
                Bridge.fireEvent('OpenLinkInBrowser', {url: url});
            });
        }
    } 
})(angular);
